<template>
  <crud-create :open="open"
               :loading="loading"
               :title="title"
               :errorMessage="errorMessage"
               @create="create"
               @close="$emit('close')"
  >
    <factura-form ref="form" v-model="form" :input-errors="inputErrors"/>
  </crud-create>
</template>

<script>

import FacturaProvider from "../../../../providers/FacturaProvider";

import {CrudCreate, ClientError} from '@dracul/common-frontend'

import FacturaForm from "../FacturaForm";


export default {
  name: "FacturaCreate",

  components: {FacturaForm, CrudCreate},

  props: {
    open: {type: Boolean, default: true}
  },

  data() {
    return {
      title: 'afip.factura.creating',
      errorMessage: '',
      inputErrors: {},
      loading: false,
      form: {
        CantReg: 1,
        PtoVta: null,
        CbteTipo: null,
        Concepto: null,
        DocTipo: null,
        DocNro: null,
        CbteDesde: null,
        CbteHasta: null,
        CbteFch: '',
        ImpTotal: null,
        ImpTotConc: 0,
        ImpNeto: null,
        ImpOpEx: 0,
        ImpIVA: null,
        ImpTrib: 0,
        MonId: 'PES',
        MonCotiz: 1,
        CAE: null,
        CAEFchVto: null,
        VoucherNumber: null,
        Error: null,
        Estado: 'PENDIENTE',
        FchServDesde: null,
        FchServHasta: null,
        FchVtoPago: null,
        CondicionIVAReceptor: '',
        RazonSocialReceptor: '',
        DomicilioReceptor: '',
        CondicionVenta: '',
        ProductoServicio: '',
        Alicuota: 5,
        detalleProductoServicio: [
          {
            codigo: '',
            ProductoServicio: '',
            cantidad: 1,
            unidadMedida:  'Unidades',
            precioUnitario:  null,
            precioUnitarioConIva:  null,
            bonificacion:  null,
            subtotal:  null,
            alicuotaIva: null,
            subtotalConIva:  null,
          }
        ]
      }
    }
  },

  methods: {
    create() {
      if (this.$refs.form.validate()) {
        this.loading = true
        FacturaProvider.createFactura(this.form).then(r => {
              if (r) {
                this.$emit('itemCreated', r.data.createFactura)
                this.$emit('close')
              }
            }
        ).catch(error => {
          let clientError = new ClientError(error)
          this.inputErrors = clientError.inputErrors
          this.errorMessage = clientError.i18nMessage
        }).finally(() => this.loading = false)
      }

    }

  },
}
</script>

<style scoped>

</style>

